import React, { useEffect, useState } from 'react'

const IframeContainerArticle = ({ articleObj }) => {
  console.log("articleObj.attributes.iframeUrl", articleObj.attributes.iframeUrl);
  const [iframeHeight, setIframeHeight] = useState();
  useEffect(() => {
    console.log("useEffect-handleIframeHeight-called")
    // handleIframeHeight()
    //document.getElementById('myIframe').contentWindow.location.reload();
    // Trigger resize when iframe loads
    if(document.getElementById('myIframe')){
      document.getElementById('myIframe').contentWindow.location.reload();
      document.getElementById('myIframe').onload = resizeIframe;
    }

    // Optional: Resize on window resize
    // window.onresize = resizeIframe;
  }, [])
  const handleIframeHeight = () => {
    console.log("handleIframeHeight-called")
    const x = document.getElementById("myFrame") ? document.getElementById("myFrame").height : "null";
    console.log("myFrame", x);
    setIframeHeight(x)
  }
  const resizeIframe = () => {
    const iframe = document.getElementById('myIframe');
    if (iframe && iframe.contentWindow) {
      iframe.style.height = iframe.contentWindow.document.body.scrollHeight + 'px';
    }
  }


  return (
    <div className={`${articleObj.attributes.articleRendering} ${articleObj.attributes.class} ${articleObj.attributes.renderType}`}>
      {/* <iframe id="myFrame" src={articleObj.attributes && articleObj.attributes.iframeUrl} onClick={handleIframeHeight}
        width={articleObj.attributes && articleObj.attributes.iframeWidth}
        height={iframeHeight ? iframeHeight : articleObj.attributes && articleObj.attributes.iframeHeight} scrolling="yes"></iframe> */}
      <iframe id="myIframe" src={articleObj.attributes && articleObj.attributes.iframeUrl} style={{ width: "100%", overflow: "hidden" }} frameborder="0"></iframe>
    </div>
  )
}

export default IframeContainerArticle
